const roundOffTwoDecimal = value => +(Math.round(value + "e+2") + "e-2");

export default roundOffTwoDecimal;
